import { MODAL_SHARE } from '@components/App/Modal/constants'
import { Tab } from '@components/App/Modal/Share/Share'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch, useSelector } from 'react-redux'

import { useProjectAccess } from '@/hooks'
import { TOOLBAR_ICONS_PERMISSION } from '@/permissions/project/definitions'

export const useShare = () => {
  const dispatch = useDispatch()

  const { hasNotAvailableAccess } = useProjectAccess(
    TOOLBAR_ICONS_PERMISSION.SHARE
  )

  const hasPassword = useSelector(
    migrationProjectSelector.getProjectHasPassword
  )

  const projectIsOnlyForMembers = useSelector(
    migrationProjectSelector.projectIsOnlyForMembers
  )

  const onShareClick = () => {
    dispatch(
      openModal({
        modalType: MODAL_SHARE,
        modalProps: { activeTab: Tab.Access },
      })
    )
  }

  return {
    hasNotAvailableAccess,
    hasPassword,
    projectIsOnlyForMembers,
    onShareClick,
  }
}
